import { Route } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import FlightListing from "../components/FlightListing";
import FlightDetailPage from "../components/FlightListItem";
import { Paths } from "../constants/Paths";
import RootLayout from "../layouts/RootLayout";
import ReviewFlightPage from "../pages/ReviewFlightPage";
import Register from "../pages/user/Register";
import BaseLayout from "../layouts/BaseLayout";
import Login from "../pages/Login";

import { RouterProvider, createBrowserRouter, Navigate } from "react-router-dom";
import { useAuth } from "../provider/AuthProvider";
import { ProtectedRoute } from "./ProtectedRoute";
import PageNotFound from "../pages/PageNotFound";
import Logout from "../pages/user/Logout";
import { Payment } from "../components/Payment";
import ViewBooking from "../pages/ViewBooking";
import MyProfile from "../pages/MyProfile";
import BookingPage from "../pages/BookingPage";
import AboutUs from "../pages/AboutUs";
import ContactUs from "../pages/ContactUs";
import Faq from "../pages/Faq";
import TermsAndConditions from "../pages/TermsAndConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { WhoAmI } from "../actions/authAction";
import CustomPayment from "../pages/CustomPayment";
import DomesticFlightListing from "../pages/Domestic/DomesticFlightListing";
import DomesticPaxInfoForm from "../pages/Domestic/DomesticPaxInfoForm";
import DomesticTicketPage from "../pages/DomesticTicketPage";
import { BUSY_CALLERS_CHANGE, CLEAR_SEARCH_DATA } from "../reducers/types";
import GeneralRules from "../pages/GeneralRules";
import { SearchResultsPage } from "../pages/TourPackage/SearchResultsPage";
import PackageDetailPage from "../pages/TourPackage/PackageDetailPage";
import DestinationDetail from "../components/Tour/DestinationDetail";
import TourBooking from "../pages/TourBooking";
import TourBookingDetail from "../pages/TourBookingDetail";
import TourPayment from "../pages/TourPayment";
import TourFPaySuccess from "../pages/TourFPaySuccess";


const Routes = () => {
  const dispatch = useDispatch();
  const { token, setToken } = useAuth();
  const [userDetail, setUserDetail] = useState(null);
  const logoutCallback = () => {
    setUserDetail(null);
    dispatch({ type: CLEAR_SEARCH_DATA });
  };
  useEffect(() => {
    if (token != null) {
      dispatch(
        WhoAmI((resp) => {
          if (resp) {
            setUserDetail(resp);
          } else {
            setToken();
          }
          dispatch({
            type: BUSY_CALLERS_CHANGE,
            payload: {
              key: '/api/UserAccount/WhoAmI',
              isBusy: false,
            },
          });
        })
      );
    } else {
      setUserDetail(null);
    }
  }, [token]);

  const router = createBrowserRouter([
    {
      element: <RootLayout userDetail={userDetail} />,
      children: [
        {
          index: true,
          path: Paths.HOME,
          element: <Dashboard />,
        },
        {
          path: Paths.ROUTE_DOMESTIC_PAXFORM,
          element: <DomesticPaxInfoForm />
        },
        {
          path: Paths.ROUTE_FLIGHTS_LIST,
          element: <FlightListing />,
        },
        {
          path: Paths.ROUTE_FLIGHTS_LIST_DOMESTIC,
          element: <DomesticFlightListing />,
        },
        {
          path: Paths.TOUR_SEARCH,
          element: <SearchResultsPage />,
        },
        {
          path: Paths.TOUR_PACKAGE_DETAIL,
          element: <PackageDetailPage />,
        },
        {
          path: Paths.TOUR_DESTINATION_DETAIL,
          element: <DestinationDetail />,
        },
        {
          path: Paths.TOUR_BOOKING,
          element: <TourBooking />,
        },
        {
          element: <BaseLayout />,
          children: [
            {
              path: Paths.ABOUT_US,
              element: <AboutUs />,
            },
            {
              path: Paths.CONTACT_US,
              element: <ContactUs />,
            },
            {
              path: Paths.FAQ,
              element: <Faq />,
            },
            {
              path: Paths.GENERAL_RULES,
              element: <GeneralRules />,
            },
            {
              path: Paths.TERMS_AND_CONDITIONS,
              element: <TermsAndConditions />,
            },
            {
              path: Paths.PRIVACY_POLICY,
              element: <PrivacyPolicy />,
            },
          ],
        },
        // Routes for non-authenticated users only
        ...(!token ? [
          {
            path: Paths.ROUTE_LOGIN,
            element: <Login />,
          },
          {
            path: Paths.ROUTE_REGISTER,
            element: <Register />,
          },
        ] : []),
        // Routes for authenticated users only
        {
          element: <ProtectedRoute />,
          children: [
            {
              path: "review",
              element: <ReviewFlightPage />,
            },
            {
              path: "payment",
              element: <Payment />,
            },
            {
              path: "profile",
              element: <MyProfile />,
            },
            {
              path: Paths.MY_BOOKINGS + "/:activeTab?",
              element: <BookingPage />,
            },
            {
              path: Paths.TOUR_BOOKING_DETAIL,
              element: <TourBookingDetail />,
            },
            {
              path: Paths.TOUR_PAYMENT,
              element: <TourPayment />,
            },
            {
              path: Paths.TOUR_FPAY_SUCCESS,
              element: <TourFPaySuccess />,
            },
            {
              path: Paths.INT_TICKET_PAGE,
              element: <ViewBooking />,
            },
            {
              path: Paths.DOMESTIC_TICKET_PAGE,
              element: <DomesticTicketPage />,
            },
            {
              path: "logout",
              element: <Logout logoutCallback={logoutCallback} />,
            },
          ],
        },
      ],
    },
    {
      path: "*",
      element: <PageNotFound />,
    },
  ]);

  return <RouterProvider router={router} />;
};

export default Routes;
